export interface UserRoleInfo {
  id: string;
  displayName: string;
}
export interface GssoUserInfo {
  gssoUserEmail: string;
  gssoUserId: string;
  roles: UserRoleInfo[];
  errors: any;
}